import { useFlags } from 'launchdarkly-react-client-sdk';
import { PermissionKey } from '../../../services/PermissionAndRolesKeys';
import { PermissionService } from '../../../services/PermissionService';
import { MaggieFeatureFlags } from '../../../util/feature-flags';

/**
 * Single gating site for the Round & Transaction Sources page, shared by the route and the Round
 * Management tab. The backend ranks by the same flag, so the page shows where a saved ranking applies.
 */
export function useSourceRankingAvailable(): boolean {
  const { rankSourceValues } = useFlags<MaggieFeatureFlags>();
  return Boolean(rankSourceValues) && PermissionService.get().hasPermission(PermissionKey.customerSuccessAll);
}
